import { createApp } from 'vue'
import axios from 'axios'
import { DateTime } from 'luxon'
import xlsx from "json-as-xlsx";

document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.js-certificate-search').forEach((el) => {
        const app = createApp({
            data() {
                return {
                    email: '',
                    certificateType: false,
                    selectedCertificate: false,
                    areasDropdownOpen: false,
                    areasDropdownSearch: '',
                    selectedArea: false,
                    certificatesDropdownOpen: false,
                    certificatesDropdownSearch: '',
                    fieldCertificateName: '',
                    fieldOrgNumber: '',
                    fieldZipCode: '',
                    fieldDistrict: '',
                    formError: false,
                    formLoading: false,
                    result: false,
                    techAreas: [],
                    orgDropdownOpen: false,
                    isSwedishOrgNumber: true,
                    init: false,
                    resultTimestamp: false,
                    counties: [],
                    municipalities: [],
                    countiesDropdownOpen: false,
                    selectedCounties: [],
                    selectedMunicipalities: [],
                    countiesSearch: '',
                    municipalitiesSearch: '',
                    municipalitiesDropdownOpen: false,
                    countiesFocusedIndex: -1,
                    municipalitiesFocusedIndex: -1,
                    isAdmin: liGlobal.isAdmin,
                }
            },
            mounted() {
                document.addEventListener('click', this.handleClickOutside)
            },
            beforeUnmount() {
                document.removeEventListener('click', this.handleClickOutside)
                document.removeEventListener('keydown', this.handleCountiesKeydown)
                document.removeEventListener('keydown', this.handleMunicipalitiesKeydown)
            },
            watch: {
                countiesFiltered: {
                    handler() {
                        this.countiesFocusedIndex = -1
                    }
                },
                municipalitiesFiltered: {
                    handler() {
                        this.municipalitiesFocusedIndex = -1
                    }
                },
            },
            async created() {
                const restBase = liGlobal.restBase

                try {
                    const softAdminResponse = await this.$http.get(restBase + '/softadmin-tech-areas', {
                        headers: { 'X-WP-Nonce': liGlobal.restNonce }
                    })

                    this.techAreas = Array.isArray(softAdminResponse.data) ? softAdminResponse.data : []
                } catch (error) {
                    this.techAreas = []
                    console.error(error)
                }

                try {
                    const countiesAndMunicipalitiesResponse = await this.$http.get(restBase + '/get-counties-and-municipalities')

                    this.counties = countiesAndMunicipalitiesResponse.data.Counties
                        .sort((a, b) => a.CountyName.localeCompare(b.CountyName, 'sv-SE'))
                        .sort((a, b) => {
                            if (a.CountyId === -1) return -1
                            if (b.CountyId === -1) return 1
                            return 0
                        })

                    this.municipalities = countiesAndMunicipalitiesResponse.data.Municipalities
                        .sort((a, b) => a.MunicipalityName.localeCompare(b.MunicipalityName, 'sv-SE'))
                        .sort((a, b) => {
                            if (a.MunicipalityId === -1) return -1
                            if (b.MunicipalityId === -1) return 1
                            return 0
                        })
                } catch (error) {
                    this.counties = []
                    this.municipalities = []
                    console.error(error)
                }

                this.init = true

                // Vanilla JS: get all buttons by class
                const buttons = document.querySelectorAll('.certificate-area-button')

                buttons.forEach((button) => {
                    button.addEventListener('click', (e) => {

                        if (button.dataset.areaId === undefined) {
                            return
                        }

                        const area = this.techAreas.find((area) => button.dataset.areaId == area.TechAreaId)
                        if (area === undefined) {
                            return
                        }

                        if (this.selectedArea !== false && this.selectedArea.areaId === area.TechAreaId) {
                            return
                        }

                        // Clear all prior selections
                        this.selectedCertificate = false
                        this.selectedArea = false
                        this.certificateType = false
                        this.formError = false
                        this.clearForm()

                        this.selectArea({
                            areaId: area.TechAreaId,
                            areaName: area.TechAreaName,
                        })
                    })
                })
            },
            computed: {
                resultJsonLabelsPerson: function() {
                    return {
                        area: { title: 'Område'},
                        organizationNumber: { title: 'Organisationsnummer'},
                        companyName: { title: 'Företagsnamn'},
                        certificateNames: { title: 'Personcertifikat'},
                        zipCode: { title: 'Postnummer'},
                        district: { title: 'Ort'},
                    }
                },
                resultJsonDataPerson: function() {
                    if (this.certificateType === false || this.certificateType !== 'person') {
                        return []
                    }

                    if (this.result === false || this.result.Companies === null) {
                        return []
                    }

                    return this.result.Companies.map((item) => {
                        return {
                            area : this.selectedArea.areaName,
                            organizationNumber : item.OrganizationNumber,
                            companyName : item.CompanyName,
                            certificateNames : item.certificateNames,
                            zipCode : item.ZipCode,
                            district : item.City
                        }
                    })
                },
                searchType: function() {
                    if (this.certificateType === false) {
                        return ''
                    }

                    return this.certificateType === 'person' ? 'Företag med certifierade personer' : 'Certifierade företag'
                },
                resultJsonLabelsCompany: function() {
                    return {
                        certificateNumber: { title: 'Certifikatsnummer'},
                        area: { title: 'Område'},
                        certificateName: { title: 'Certifikatstyp'},
                        validTo: { title: 'Giltigt t.o.m.'},
                        organizationNumber: { title: 'Organisationsnummer'},
                        companyName: { title: 'Företagsnamn'},
                        address: { title: 'Adress'},
                        zipCode: { title: 'Postnummer'},
                        district: { title: 'Ort'},
                        country: { title: 'Land' },
                    }
                },
                resultJsonDataCompany: function() {
                    if (this.certificateType === false || this.certificateType === 'person') {
                        return []
                    }

                    if (this.result === false || this.result.CompanyCertificates === null) {
                        return []
                    }

                    return this.result.CompanyCertificates.map((item) => {
                        return {
                            certificateNumber : item.CertificateNumber,
                            area : this.selectedArea.areaName,
                            certificateName : item.CertificateName,
                            validTo : item.DateValidTo,
                            organizationNumber : item.OrganizationNumber,
                            companyName : item.CompanyName,
                            address : item.Address,
                            zipCode : item.ZipCode,
                            district : item.City,
                            country: item.Country,
                        }
                    })
                },
                excelPersonData: function () {
            return [
                {
                    sheet: 'Företag m certifierade personer',
                    columns: [
                        { label: 'Område', value: 'area' },
                        { label: 'Organisationsnummer', value: 'organizationNumber' },
                        { label: 'Företagsnamn', value: 'companyName' },
                        { label: 'Personcertifikat', value: 'certificateNames' },
                        { label: 'Postnummer', value: 'zipCode' },
                        { label: 'Ort', value: 'district' },
                    ],
                    content: this.resultJsonDataPerson
                }
            ]
        },
        excelCompanyData: function () {
            return [
                {
                    sheet: 'Certifierade företag',
                    columns: [
                        { label: 'Certifikatsnummer', value: 'certificateNumber' },
                        { label: 'Område', value: 'area' },
                        { label: 'Certifikatstyp', value: 'certificateName' },
                        { label: 'Giltigt t.o.m.', value: 'validTo' },
                        { label: 'Organisationsnummer', value: 'organizationNumber' },
                        { label: 'Företagsnamn', value: 'companyName' },
                        { label: 'Adress', value: 'address' },
                        { label: 'Postnummer', value: 'zipCode' },
                        { label: 'Ort', value: 'district' },
                        { label: 'Land', value: 'country' },
                    ],
                    content: this.resultJsonDataCompany
                }
            ]
        },
        excelSettings: function () {
            return {
                fileName: 'Incert Sökresultat - ' + this.getDateNow(),
                extraLength: 3,
                writeOptions: {}
            }
        },
                formattedFieldOrgNumber: {
                    set: function(val) {
                        const number = val.replaceAll('-', '')
                        this.fieldOrgNumber = number
                    },
                    get: function() {
                        const number = this.fieldOrgNumber

                        if (number.length === 6) {
                            return number + '-'
                        }

                        if (number.length > 6) {
                            return number.substring(0,6) + '-' + number.substring(6)
                        } else {
                            return number
                        }
                    },
                },
                formattedZipCode: {
                    set: function(val) {
                        const number = val.replaceAll(' ', '')
                        this.fieldZipCode = number
                    },
                    get: function() {
                        const number = this.fieldZipCode

                        if (number.length === 3) {
                            return number + ' '
                        }

                        if (number.length > 3) {
                            return number.substring(0,3) + ' ' + number.substring(3)
                        } else {
                            return number
                        }
                    }
                },
                areas: function() {
                    const returnArr = []
                    this.techAreas.forEach((area) => {
                        if (area.CertificateTemplates !== null) {
                            returnArr.push({
                                areaId: area.TechAreaId,
                                areaName: area.TechAreaName,
                            })
                        }
                    })

                    returnArr.sort((a,b) => {
                        return a.areaName.localeCompare(b.areaName, 'sv')
                    })

                    if (this.areasDropdownSearch.trim() == '') {
                        return returnArr
                    } else {
                        return returnArr.filter((item) => {
                            return item.areaName.toLowerCase().includes(this.areasDropdownSearch.toLowerCase())
                        })
                    }
                },
                certificates: function() {
                    const returnArr = []

                    if (this.certificateType === false || this.selectedArea === false) {
                        return []
                    }

                    const area = this.techAreas.find((area) => {
                        return area.TechAreaId === this.selectedArea.areaId
                    })

                    if (area === undefined || area.CertificateTemplates === null) {
                        return []
                    }

                    area.CertificateTemplates.forEach((template) => {
                        if (template.IsRecertificate === false) {
                            if (this.certificateType === 'company') {
                                if (template.IsCompanyCertificate === true) {
                                    returnArr.push(template)
                                }
                            } else if (this.certificateType === 'person') {
                                if (template.IsCompanyCertificate === false) {
                                    returnArr.push(template)
                                }
                            }
                        }
                    })

                    returnArr.sort((a,b) => {
                        return a.TemplateName.localeCompare(b.TemplateName, 'sv')
                    })

                    if (this.certificatesDropdownSearch.trim() == '') {
                        return returnArr
                    } else {
                        return returnArr.filter((item) => {
                            return item.TemplateName.toLowerCase().includes(this.certificatesDropdownSearch.toLowerCase())
                        })
                    }
                },
                countiesFiltered: function() {
                    if (this.countiesSearch.trim() == '') {
                        return this.counties
                    } else {
                        return this.counties.filter((item) => {
                            return item.CountyName.toLowerCase().includes(this.countiesSearch.trim().toLowerCase())
                        })
                    }
                },
                isCin2Area: function() {
                    if (this.selectedArea === false || !this.selectedArea.areaName) {
                        return false
                    }

                    return /cin\s*2/i.test(this.selectedArea.areaName)
                },
                showCountyMunicipality: function() {
                    return this.isAdmin || this.isCin2Area
                },
                municipalitiesFiltered: function() {
                    const returnArr = []

                    if (this.selectedCounties.length > 0) {
                        if (this.selectedCounties.length === 1 && this.selectedCounties[0].CountyId === -1) {
                            return this.municipalities
                        }

                        this.selectedCounties.forEach((county) => {
                            const municipalities = this.municipalities.filter((municipality) => {
                                return municipality.CountyId === county.CountyId
                            })

                            returnArr.push(...municipalities)
                        })
                    } else {
                        returnArr.push(...this.municipalities)
                    }

                    if (this.municipalitiesSearch.trim() == '') {
                        return returnArr
                    } else {
                        return returnArr.filter((item) => {
                            return item.MunicipalityName.toLowerCase().includes(this.municipalitiesSearch.trim().toLowerCase())
                        })
                    }
                },
            },
            methods: {
                removeMunicipality(municipality) {
                    this.selectedMunicipalities = this.selectedMunicipalities.filter((item) => {
                        return item !== municipality
                    })
                },
                clearMunicipalities() {
                    this.selectedMunicipalities = []
                },
                handleMunicipalitiesKeydown: function(event) {
                    if (!this.municipalitiesDropdownOpen || this.municipalitiesFiltered.length === 0) return

                    switch (event.key) {
                        case 'ArrowDown':
                            event.preventDefault()
                            this.municipalitiesFocusedIndex =
                                this.municipalitiesFocusedIndex < this.municipalitiesFiltered.length - 1
                                    ? this.municipalitiesFocusedIndex + 1
                                    : this.municipalitiesFocusedIndex
                            this.scrollToFocusedMunicipalityOption()
                            break

                        case 'ArrowUp':
                            event.preventDefault()
                            this.municipalitiesFocusedIndex =
                                this.municipalitiesFocusedIndex > -1
                                    ? this.municipalitiesFocusedIndex - 1
                                    : -1
                            this.scrollToFocusedMunicipalityOption()
                            break

                        case 'Enter':
                            event.preventDefault()
                            if (this.municipalitiesFocusedIndex >= 0) {
                                this.selectMunicipality(this.municipalitiesFiltered[this.municipalitiesFocusedIndex])
                            } else if (this.municipalitiesFiltered.length === 1) {
                                this.selectMunicipality(this.municipalitiesFiltered[0])
                            }
                            break

                        case 'Escape':
                            this.municipalitiesDropdownOpen = false
                            this.municipalitiesFocusedIndex = -1
                            break
                    }
                },
                scrollToFocusedMunicipalityOption: function() {
                    this.$nextTick(() => {
                        const focusedElement = el.querySelector('.certificate-search-dropdown.county-municipality .option.keyboard-focus')
                        const resultWrapper = el.querySelector('.certificate-search-dropdown.county-municipality .result-wrapper')
                        if (focusedElement && resultWrapper) {
                            const wrapperRect = resultWrapper.getBoundingClientRect()
                            const elementRect = focusedElement.getBoundingClientRect()

                            const isAbove = elementRect.top < wrapperRect.top
                            const isBelow = elementRect.bottom > wrapperRect.bottom

                            if (isAbove) {
                                resultWrapper.scrollTop += elementRect.top - wrapperRect.top
                            } else if (isBelow) {
                                resultWrapper.scrollTop += elementRect.bottom - wrapperRect.bottom
                            }
                        }
                    })
                },
                toggleMunicipalityDropdown: function() {
                    this.countiesDropdownOpen = false
                    this.municipalitiesDropdownOpen = !this.municipalitiesDropdownOpen
                    this.municipalitiesFocusedIndex = -1

                    if (this.municipalitiesDropdownOpen) {
                        document.addEventListener('keydown', this.handleMunicipalitiesKeydown)
                        this.$nextTick(() => {
                            this.$refs.municipalitiesSearch.focus()
                        })
                    } else {
                        document.removeEventListener('keydown', this.handleMunicipalitiesKeydown)
                    }
                },
                handleCountiesKeydown: function(event) {
                    if (!this.countiesDropdownOpen || this.countiesFiltered.length === 0) return

                    switch (event.key) {
                        case 'ArrowDown':
                            event.preventDefault()
                            this.countiesFocusedIndex =
                                this.countiesFocusedIndex < this.countiesFiltered.length - 1
                                    ? this.countiesFocusedIndex + 1
                                    : this.countiesFocusedIndex
                            this.scrollToFocusedOption()
                            break

                        case 'ArrowUp':
                            event.preventDefault()
                            this.countiesFocusedIndex =
                                this.countiesFocusedIndex > -1
                                    ? this.countiesFocusedIndex - 1
                                    : -1
                            this.scrollToFocusedOption()
                            break

                        case 'Enter':
                            event.preventDefault()
                            if (this.countiesFocusedIndex >= 0) {
                                this.selectCounty(this.countiesFiltered[this.countiesFocusedIndex])
                            } else if (this.countiesFiltered.length === 1) {
                                this.selectCounty(this.countiesFiltered[0])
                            }
                            break

                        case 'Escape':
                            this.countiesDropdownOpen = false
                            this.countiesFocusedIndex = -1
                            break
                    }
                },
                scrollToFocusedOption: function() {
                    this.$nextTick(() => {
                        const focusedElement = el.querySelector('.option.keyboard-focus')
                        const resultWrapper = el.querySelector('.result-wrapper')
                        if (focusedElement && resultWrapper) {
                            const wrapperRect = resultWrapper.getBoundingClientRect()
                            const elementRect = focusedElement.getBoundingClientRect()

                            const isAbove = elementRect.top < wrapperRect.top
                            const isBelow = elementRect.bottom > wrapperRect.bottom

                            if (isAbove) {
                                resultWrapper.scrollTop += elementRect.top - wrapperRect.top
                            } else if (isBelow) {
                                resultWrapper.scrollTop += elementRect.bottom - wrapperRect.bottom
                            }
                        }
                    })
                },
                toggleCountyDropdown: function() {
                    this.municipalitiesDropdownOpen = false
                    this.countiesDropdownOpen = !this.countiesDropdownOpen
                    this.countiesFocusedIndex = -1

                    if (this.countiesDropdownOpen) {
                        document.addEventListener('keydown', this.handleCountiesKeydown)
                        this.$nextTick(() => {
                            this.$refs.countiesSearch.focus()
                        })
                    } else {
                        document.removeEventListener('keydown', this.handleCountiesKeydown)
                    }
                },
                handleClickOutside(event) {
                    if (this.$refs.countyDropdown && !this.$refs.countyDropdown.contains(event.target)) {
                        this.countiesDropdownOpen = false
                        this.countiesFocusedIndex = -1
                        document.removeEventListener('keydown', this.handleCountiesKeydown)
                    }

                    if (this.$refs.municipalityDropdown && !this.$refs.municipalityDropdown.contains(event.target)) {
                        this.municipalitiesDropdownOpen = false
                        this.municipalitiesFocusedIndex = -1
                        document.removeEventListener('keydown', this.handleMunicipalitiesKeydown)
                    }
                },
                removeCounty(county) {
                    this.selectedCounties = this.selectedCounties.filter((item) => {
                        return item !== county
                    })
                },
                isCountySelected(option) {
                    return this.selectedCounties.some(county => county.CountyId === option.CountyId)
                },
                isMunicipalitySelected(option) {
                    return this.selectedMunicipalities.some(municipality => municipality.MunicipalityId === option.MunicipalityId)
                },
                selectCounty: function(county) {
                    this.selectedMunicipalities = []

                    if (county.CountyId === -1) {
                        if (this.selectedCounties[0] === county) {
                            this.selectedCounties = []
                        } else {
                            this.selectedCounties = [county]
                        }
                    } else {
                        if (this.selectedCounties.find((county) => county.CountyId === -1) !== undefined) {
                            this.selectedCounties = []
                        }

                        if (this.selectedCounties.includes(county)) {
                            this.selectedCounties = this.selectedCounties.filter((item) => {
                                return item !== county
                            })
                        } else {
                            this.selectedCounties.push(county)
                        }
                    }

                    this.countiesSearch = ''
                },
                selectMunicipality: function(municipality) {
                    if (municipality.MunicipalityId === -1) {
                        if (this.selectedMunicipalities[0] === municipality) {
                            this.selectedMunicipalities = []
                        } else {
                            this.selectedMunicipalities = [municipality]
                        }
                    } else {
                        if (this.selectedMunicipalities.find((municipality) => municipality.MunicipalityId === -1) !== undefined) {
                            this.selectedMunicipalities = []
                        }

                        if (this.selectedMunicipalities.includes(municipality)) {
                            this.selectedMunicipalities = this.selectedMunicipalities.filter((item) => {
                                return item !== municipality
                            })
                        } else {
                            this.selectedMunicipalities.push(municipality)
                        }
                    }

                    this.municipalitiesSearch = ''
                },
                getDateNow: function() {
                    return this.resultTimestamp.replaceAll(':', '.')
                },
                selectOrgType: function(type) {
                    this.fieldOrgNumber = ''
                    this.fieldZipCode = ''
                    this.orgDropdownOpen = false
                    this.isSwedishOrgNumber = type
                },
                selectCertificateType: function(type) {
                    if (this.certificateOfTypeExists(type) === false) {
                        return
                    }

                    if (type === this.certificateType) {
                        return
                    }

                    if (this.selectedCertificate !== false) {
                        this.selectedCertificate = false
                    }

                    this.clearForm()
                    this.certificateType = type
                },
                onlyNumber($event) {
                    let keyCode = ($event.keyCode ? $event.keyCode : $event.which)
                    if ((keyCode < 48 || keyCode > 57) && keyCode !== 46) {
                        $event.preventDefault()
                    }
                },
                onlyNumberOrg($event) {
                    if ($event.target.value.length > 10) {
                        $event.preventDefault()
                        return
                    }
                    let keyCode = ($event.keyCode ? $event.keyCode : $event.which)
                    if ((keyCode < 48 || keyCode > 57) && keyCode !== 46) {
                        $event.preventDefault()
                    }
                },
                onlyNumberZipCode($event) {
                    if ($event.target.value.length > 5) {
                        $event.preventDefault()
                        return
                    }
                    let keyCode = ($event.keyCode ? $event.keyCode : $event.which)
                    if ((keyCode < 48 || keyCode > 57) && keyCode !== 46) {
                        $event.preventDefault()
                    }
                },
                test: function(date) {
                    const today = new Date()
                    return date > today
                },
                selectArea: function(selected) {
                    this.selectedCertificate = false
                    this.selectedArea = selected
                    this.areasDropdownSearch = ''
                    this.areasDropdownOpen = false
                    this.certificateType = false
                    this.selectedCertificate = false
                    this.clearForm()

                    const area = this.techAreas.find((area) => {
                        return area.TechAreaId === this.selectedArea.areaId
                    })

                    if (area === undefined || area.CertificateTemplates === null) {
                        return
                    }

                    if (area.CertificateTemplates.length > 0) {
                        const companyCertificates = area.CertificateTemplates.filter((template) => {
                            return template.IsCompanyCertificate === true
                        })

                        const personCertificates = area.CertificateTemplates.filter((template) => {
                            return template.IsCompanyCertificate === false
                        })

                        if (personCertificates.length === 0) {
                            this.certificateType = 'company'
                        } else if (companyCertificates.length === 0) {
                            this.certificateType = 'person'
                        }
                    }
                },
                certificateOfTypeExists: function(type) {
                    if (this.selectedArea === false) {
                        return false
                    }

                    const area = this.techAreas.find((area) => {
                        return area.TechAreaId === this.selectedArea.areaId
                    })

                    if (area === undefined || area.CertificateTemplates === null) {
                        return false
                    }

                    if (type === 'company') {
                        return area.CertificateTemplates.some((template) => {
                            return template.IsCompanyCertificate === true
                        })
                    } else if (type === 'person') {
                        return area.CertificateTemplates.some((template) => {
                            return template.IsCompanyCertificate === false
                        })
                    }

                    return false
                },
                selectCertificate: function(selected) {
                    this.certificatesDropdownOpen = false
                    this.selectedCertificate = selected
                    this.certificatesDropdownSearch = ''
                    this.clearForm()
                },
                clearCounties: function() {
                    this.selectedCounties = []
                },
                clearForm: function() {
                    this.result = false
                    this.fieldCertificateName = ''
                    this.fieldOrgNumber = ''
                    this.fieldZipCode = ''
                    this.fieldDistrict = ''
                    this.isSwedishOrgNumber = true
                    this.resultTimestamp = false
                    this.selectedCounties = []
                    this.selectedMunicipalities = []
                    this.countiesSearch = ''
                    this.municipalitiesSearch = ''
                    this.countiesDropdownOpen = false
                    this.municipalitiesDropdownOpen = false

                    document.removeEventListener('keydown', this.handleCountiesKeydown)
                    document.removeEventListener('keydown', this.handleMunicipalitiesKeydown)
                },
                validateForm: function() {
                    if (this.formLoading == true) {
                        return
                    }

                    // Honeypot field
                    if (this.email !== '') {
                        return
                    }

                    this.result = false
                    this.formError = false

                    const name = this.fieldCertificateName.trim()
                    const zipCode = this.fieldZipCode.trim()
                    const district = this.fieldDistrict.trim()
                    const orgNumber = this.fieldOrgNumber.trim()

                    const countiesLength = this.showCountyMunicipality ? this.selectedCounties.length : 0
                    const municipalitiesLength = this.showCountyMunicipality ? this.selectedMunicipalities.length : 0

                    if (this.certificateType === 'person') {
                        if (zipCode === '' && district === '' && countiesLength === 0 && municipalitiesLength === 0) {
                            this.formError = {field: '', message: 'ange minst ett sökkriterium'}
                            return
                        }
                    } else if (this.certificateType === 'company') {
                        if (orgNumber === ''  && name === '' && zipCode === '' && district === '' && countiesLength === 0 && municipalitiesLength === 0) {
                            this.formError = {field: '', message: 'ange minst ett sökkriterium'}
                            return
                        }

                        if (orgNumber !== '' && this.isSwedishOrgNumber === true && orgNumber.length !== 10) {
                            this.formError = {field: 'fieldOrgNumber', message: 'ange ett fullständigt organisationsnummer (10 siffror)'}
                            return
                        }
                    }

                    this.formLoading = true

                    const restBase = liGlobal.restBase
                    let query

                    let counties = ''
                    let municipalities = ''

                    if (this.showCountyMunicipality && this.selectedCounties.length > 0) {
                        counties = this.selectedCounties.map((county) => {
                            return county.CountyId
                        }).join(',')
                    }

                    if (this.showCountyMunicipality && this.selectedMunicipalities.length > 0) {
                        municipalities = this.selectedMunicipalities.map((municipality) => {
                            return municipality.MunicipalityId
                        }).join(',')
                    }

                    if (this.certificateType === 'company') {
                        query = '?CompanyName=' + encodeURIComponent(name) + '&OrganizationNumber=' + encodeURIComponent(orgNumber) + '&IsSwedishOrganizationNumber=' + (this.isSwedishOrgNumber === true ? '1' : '0') + '&ZipCode=' + encodeURIComponent(zipCode) + '&City=' + encodeURIComponent(district) + '&TechAreaId=' + this.selectedArea.areaId + '&TemplateId=' + this.selectedCertificate.TemplateId + '&CountyId=' + counties + '&MunicipalityId=' + municipalities

                        this.$http.get(restBase + '/softadmin-search-company' + query, {
                            headers: { 'X-WP-Nonce': liGlobal.restNonce }
                        }).then((response) => {
                            this.formLoading = false
                            this.resultTimestamp = DateTime.now().toFormat('yyyy-MM-dd HH:mm')
                            if (response.data.CompanyCertificates !== null && response.data.CompanyCertificates.length > 0) {
                                response.data.CompanyCertificates.forEach((certificate) => {
                                    certificate.isOpen = false
                                })

                                response.data.CompanyCertificates.sort((a, b) => {
                                    return a.CompanyName.localeCompare(b.CompanyName, 'sv')
                                })
                            }

                            this.result = response.data
                        })
                        .catch((error) => {
                            this.formLoading = false
                            this.formError = { field: '', message: 'Kunde inte hämta sökresultat. Försök igen.' }
                            console.log(error)
                        })
                    } else if (this.certificateType === 'person') {
                        query = '?ZipCode=' + encodeURIComponent(zipCode) + '&City=' + encodeURIComponent(district) + '&TechAreaId=' + this.selectedArea.areaId + '&CountyId=' + counties + '&MunicipalityId=' + municipalities

                        this.$http.get(restBase + '/softadmin-search-person' + query, {
                            headers: { 'X-WP-Nonce': liGlobal.restNonce }
                        }).then((response) => {
                            this.formLoading = false
                            this.resultTimestamp = DateTime.now().toFormat('yyyy-MM-dd HH:mm')
                            if (response.data.Companies !== null && response.data.Companies.length > 0) {
                                response.data.Companies.forEach((company) => {
                                    let certificateNames = ''

                                    if (company.EmployeeCertificates !== null && company.EmployeeCertificates.length > 0) {
                                        company.EmployeeCertificates.forEach((certificate) => {
                                            if (certificate.DoExistEmployeeWithActiveCertificate === true) {
                                                certificateNames += certificate.CertificateName + ', '
                                            }
                                        })

                                        certificateNames = certificateNames.substring(0, certificateNames.length - 2)
                                        company.certificateNames = certificateNames
                                    }

                                    company.isOpen = false
                                })

                                response.data.Companies.sort((a, b) => {
                                    return a.CompanyName.localeCompare(b.CompanyName, 'sv')
                                })
                            }

                            this.result = response.data
                        })
                        .catch((error) => {
                            this.formLoading = false
                            this.formError = { field: '', message: 'Kunde inte hämta sökresultat. Försök igen.' }
                            console.log(error)
                        })
                    }
                },
                escapeCsvValue: function (value, separator) {
                    const string = value == null ? '' : String(value)

                    if (string.includes('"') || string.includes('\n') || string.includes('\r') || string.includes(separator)) {
                        return '"' + string.replaceAll('"', '""') + '"'
                    }

                    return string
                },
                downloadCsv: function () {
                    const rows = this.certificateType === 'company' ? this.resultJsonDataCompany : this.resultJsonDataPerson
                    const labels = this.certificateType === 'company' ? this.resultJsonLabelsCompany : this.resultJsonLabelsPerson
                    const separator = ';'

                    if (!rows.length) {
                        return
                    }

                    const keys = Object.keys(labels)
                    const header = keys.map((key) => this.escapeCsvValue(labels[key].title, separator)).join(separator)
                    const body = rows.map((row) => {
                        return keys.map((key) => this.escapeCsvValue(row[key], separator)).join(separator)
                    }).join('\r\n')

                    const blob = new Blob(['\uFEFF' + header + '\r\n' + body], { type: 'text/csv;charset=utf-8;' })
                    const url = URL.createObjectURL(blob)
                    const link = document.createElement('a')
                    link.href = url
                    link.download = 'Incert Sökresultat - ' + this.getDateNow() + '.csv'
                    document.body.appendChild(link)
                    link.click()
                    document.body.removeChild(link)
                    URL.revokeObjectURL(url)
                },
                downloadExcel: function () {
                    if (this.certificateType === 'person') {
                        xlsx(this.excelPersonData, this.excelSettings)
                    } else if (this.certificateType === 'company') {
                        xlsx(this.excelCompanyData, this.excelSettings)
                    }
                }
            },
        })

        app.config.globalProperties.$http = axios
        app.config.globalProperties.axios = axios
        app.mount(el)
    })
})
